export enum CustomFieldTypeEnum {
    String = 0,
    Integer = 1,
    Double = 2,
    Decimal = 3,
    Boolean = 4,
    DateTime = 5,
    SingleSelect = 6,

    Floor = 100,
    Latitude = 101,
    Longitude = 102,
    IsStaticLocation = 103,

    HrisEmployeeType = 1000,
    HrisPersonId = 1001,
    HrisFirstName = 1002,
    HrisLastName = 1003,
    HrisLastName2 = 1004,
    HrisOrganizationalUnitId = 1005,
    HrisSupervisorPersonId = 1006,
    HrisEmailId = 1007,
    HrisSupervisorEmail = 1008,
    HrisPosition = 1009,
    HrisJobName = 1010,
    HrisJobCode = 1011,
    HrisShiftCode = 1012,
    HrisDateOfHire = 1013,
    HrisDateOfTermination = 1014,
    HrisContractingCompany = 1015,
    HrisWorkLocation = 1016,
}

export const UniqueTypes: CustomFieldTypeEnum[] = [
    CustomFieldTypeEnum.Longitude,
    CustomFieldTypeEnum.Latitude,
    CustomFieldTypeEnum.IsStaticLocation,
    CustomFieldTypeEnum.Floor
];

export function isUniqueType(type: CustomFieldTypeEnum): boolean {
    return UniqueTypes.includes(type);
}

export const HrisTypes: CustomFieldTypeEnum[] = [
    CustomFieldTypeEnum.HrisEmployeeType,
    CustomFieldTypeEnum.HrisPersonId,
    CustomFieldTypeEnum.HrisFirstName,
    CustomFieldTypeEnum.HrisLastName,
    CustomFieldTypeEnum.HrisLastName2,
    CustomFieldTypeEnum.HrisOrganizationalUnitId,
    CustomFieldTypeEnum.HrisSupervisorPersonId,
    CustomFieldTypeEnum.HrisEmailId,
    CustomFieldTypeEnum.HrisSupervisorEmail,
    CustomFieldTypeEnum.HrisPosition,
    CustomFieldTypeEnum.HrisJobName,
    CustomFieldTypeEnum.HrisJobCode,
    CustomFieldTypeEnum.HrisShiftCode,
    CustomFieldTypeEnum.HrisDateOfHire,
    CustomFieldTypeEnum.HrisDateOfTermination,
    CustomFieldTypeEnum.HrisContractingCompany,
    CustomFieldTypeEnum.HrisWorkLocation
];

export const EmployeeCustomFields: CustomFieldTypeEnum[] = [
  CustomFieldTypeEnum.HrisEmployeeType,
  CustomFieldTypeEnum.HrisFirstName,
  CustomFieldTypeEnum.HrisLastName,
  CustomFieldTypeEnum.HrisLastName2,
  CustomFieldTypeEnum.HrisEmailId,
  CustomFieldTypeEnum.HrisPosition
];